export default {
  lastname: {
    presence: { allowEmpty: false, message: 'is required' }
  },
  firstname: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
